import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import MessageDialog, {
  MessageDialogInterfaceProps,
} from 'react-components/dialog-forms/message/MessageDialog';

export type MessageDialogCallbackInput = {};

const { useDialogForContext, useDialog: useMessageDialog } = getDialogHooks<
  MessageDialogInterfaceProps,
  MessageDialogCallbackInput
>(MessageDialog);
export const useMessageDialogForContext = useDialogForContext;
export default useMessageDialog;
